/**
 * Campaign Color Utilities
 * 
 * Color palette and helpers for multi-campaign views.
 */

// Color palette for campaign indicators
export const CAMPAIGN_COLORS = [
  '#6366f1', // Indigo
  '#8b5cf6', // Violet  
  '#ec4899', // Pink
  '#f97316', // Orange
  '#10b981', // Emerald
  '#06b6d4', // Cyan
  '#f59e0b', // Amber
  '#ef4444', // Red
];

/**
 * Get a color for a campaign based on its index
 * @param {number} index - Campaign index in sorted list
 * @returns {string} Hex color code
 */
export function getCampaignColor(index) {
  return CAMPAIGN_COLORS[index % CAMPAIGN_COLORS.length];
}
